import React from "react";
import environment from "web/script/modules/environment";
import { setPaidSessionIdOnUrl } from "web/script/utils/paid-session-id";

type LinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

export default function Link(props: LinkProps): JSX.Element {
    let href = props.href;

    if (href && environment.has("paidSessionId")) {
        href = setPaidSessionIdOnUrl(href, environment.get("paidSessionId"));
    }

    return <a {...props} href={href} />;
}
